import Spinner from "@/components/Spinner";
import { recentEventType } from "@/mappings/dashboard";
import { RecentEvent } from "@/types/Dashboard";
import { User } from "@/types/User";
import Avatar from "@components/Avatar";
import Tooltip from "@components/Tooltip";
import Typography from "@components/Typography";
import { i18n } from "@lingui/core";

import styles from "./Colleagues.module.css";

const Colleagues = (props: {
  recentEvents?: RecentEvent[];
  recentEventsError: Error | null;
  usersError: Error | null;
  users?: User[];
}) => {
  const filteredUsers = props.users?.filter((user) => Boolean(user.name));
  const filteredEvents = props.recentEvents?.filter((event) =>
    Boolean(event.user)
  );

  return (
    <div data-testid="dashboard--colleagues" className={styles.colleagues}>
      <Typography variant="subtitle-1" className={styles["colleagues__title"]}>
        {L.DASHBOARD__COLLEAGUES__TITLE}
      </Typography>

      <hr className={styles["colleagues__divider"]} />

      <div className={styles["colleagues__inner"]}>
        <div className={styles["colleagues__last-logged-in"]}>
          <Typography
            variant="subtitle-2"
            className={styles["colleagues__last-logged-in__title"]}
          >
            {L.DASHBOARD__COLLEAGUES__LAST_LOGGED_IN__TITLE}
          </Typography>

          {filteredUsers ? (
            filteredUsers.length ? (
              <div
                className={styles["colleagues__last-logged-in__avatar-group"]}
              >
                {filteredUsers.map((user) => (
                  <Tooltip key={user.id} content={user.name}>
                    <div
                      className={
                        styles["colleagues__last-logged-in__avatar-group__item"]
                      }
                    >
                      <Avatar
                        size={40}
                        full_name={user.name}
                        first_name={user.first_name || user.name?.split(" ")[0]}
                        last_name={user.last_name || user.name?.split(" ")[1]}
                        className={
                          styles[
                            "colleagues__last-logged-in__avatar-group__item__avatar"
                          ]
                        }
                      />
                    </div>
                  </Tooltip>
                ))}
              </div>
            ) : null
          ) : props.usersError ? (
            <Typography>{L.GENERIC_ERROR}</Typography>
          ) : (
            <Spinner />
          )}
        </div>

        <div className={styles["colleagues__activity"]}>
          <Typography
            variant="subtitle-2"
            className={styles["colleagues__activity__title"]}
          >
            {L.DASHBOARD__COLLEAGUES__LATEST_ACTIVITY__TITLE}
          </Typography>

          {filteredEvents ? (
            filteredEvents.length ? (
              <ul className={styles["colleagues__activity__list"]}>
                {filteredEvents.map((e) => {
                  const firstName = e.user!.first_name;
                  const lastName = e.user!.last_name;
                  const fullName = e.user!.display_name || e.user!.name;

                  const eventText = recentEventType[e.event_type];

                  return (
                    <li
                      key={e.event_type + e.timestamp + e.user!.id}
                      className={styles["colleagues__activity__list__item"]}
                    >
                      <Avatar
                        size={38}
                        last_name={lastName}
                        full_name={fullName}
                        first_name={firstName}
                      />

                      <Typography
                        variant="body-1"
                        className={
                          styles["colleagues__activity__list__item__text"]
                        }
                      >
                        <b>{fullName}</b>
                        {eventText.startsWith(":s") ||
                        eventText.startsWith("’s")
                          ? ""
                          : " "}
                        {i18n._(eventText)}
                      </Typography>
                    </li>
                  );
                })}
              </ul>
            ) : null
          ) : props.recentEventsError ? (
            <Typography>{L.GENERIC_ERROR}</Typography>
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    </div>
  );
};

export default Colleagues;
